import moment, {Moment} from "moment";
import {DatePicker, RedAsterisk} from "../../../../components";
import {DISPLAY_DATE_FORMAT} from "../../../../constants/common";
import {useAppSelector} from "../../../../store/hooks";
import {saveSelector} from "../../../slices/NavigationSlice";
import {isValid} from "../../../validation/ValidationUtils";
import "./_date-field.scss";
import React from "react";

interface DateFieldProps {
    date: string;
    label: string;
    onChange: (date: Moment) => void;
    required?: boolean;
}

function DateField({date, label, onChange, required = false} : Readonly<DateFieldProps>) {
    const saveHasBeenClicked = useAppSelector(saveSelector);

    const hasError = () => {
        return required && saveHasBeenClicked && !isValid(date);
    }

    return (
        <div className="layout-data-entry-form__field">
            <label className={"h5"} data-testid={'date-created'}>
                {label}
                {required && <RedAsterisk/>}
            </label>
            <DatePicker
                className="createdDateField"
                id="createdDateInput"
                aria-label="Date Created"
                displayFormat={DISPLAY_DATE_FORMAT}
                hideKeyboardShortcutsPanel
                isOutsideRange={(date: Moment) => date.isAfter(moment().endOf('day'))}
                date={date ? moment(date) : undefined}
                error={hasError() ? `${label} is required.` : undefined}
                onDateChange={(date: Moment) => onChange(date)}
            />
        </div>
    );
}

export default DateField;